import type { IconName } from "./Icon";

export const stepTabs = [
  { key: "code", label: "Code", icon: "code", shortcut: "1" },
  { key: "output", label: "Data", icon: "table", shortcut: "0" },
  { key: "files", label: "Files", icon: "folder" },
  { key: "browser", label: "Browser", icon: "compass" },
] as const satisfies readonly {
  key: string;
  label: string;
  icon: IconName;
  shortcut?: string;
}[];

export type StepTab = (typeof stepTabs)[number]["key"];

export const stepTabShortcuts = stepTabs
  .filter((tab) => "shortcut" in tab)
  .toSorted((a, b) => Number(a.shortcut) - Number(b.shortcut));

export function resolveStepTab({
  stepTab,
  showRuns,
  file,
  browserApplicable = false,
  execution,
  forceShowCode = false,
  expandOutput = false,
}: {
  stepTab?: string;
  showRuns?: string;
  file?: string;
  browserApplicable?: boolean;
  execution?: string;
  forceShowCode?: boolean;
  expandOutput?: boolean;
}): StepTab {
  const defaultTab = browserApplicable && !execution ? "browser" : "output";
  if (forceShowCode) return expandOutput ? defaultTab : "code";
  if (stepTab === "browser") return browserApplicable ? "browser" : "output";
  const selected = stepTabs.find((tab) => tab.key === stepTab);
  if (selected) return selected.key;
  if (stepTab === "readme") return "code";
  if (stepTab === "runs" || showRuns) return "output";
  if (file) return "code";
  return defaultTab;
}
